module.exports = __webpack_public_path__ + "img/slash.svg?697ff26b120e456915729e22e678e424";